import React from 'react';

export type P_InputColor = P_InputColorBase & {
	id: string;
	label: string;
};
export type P_InputColorBase = {
	onInput: (value: string) => any;
	value: string;
};
export default function InputColor(props: P_InputColor) {
	const onInput = (event: React.FormEvent<HTMLInputElement>) => {
		props.onInput(event.currentTarget.value);
	};

	return (
		<div>
			<input
				type='color'
				id={props.id}
				name={props.id}
				value={props.value}
				onInput={onInput}
			/>
			<label htmlFor={props.id} style={labelStyle}>
				{props.label}
			</label>
		</div>
	);
}

const labelStyle = {
	marginLeft: 8,
	fontSize: '0.75rem',
	fontColor: 'rgba(0, 0, 0, 0.6)',
};
